import { render } from "./RoomGuestQuantity.vue?vue&type=template&id=035d98b4"
import script from "./RoomGuestQuantity.vue?vue&type=script&lang=js"
export * from "./RoomGuestQuantity.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MT/2025/jebsen/files/components/com_cruise/assets/js/booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__